var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeasons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.85 14.14a1.13 1.13 0 0 0 .125-.797 1.114 1.114 0 0 0-1.32-.866l-4.097 1.174L12.375 12l3.183-1.65 4.097 1.173a1.114 1.114 0 0 0 1.32-.866 1.125 1.125 0 0 0-.858-1.335l-2.225-.334 2.488-1.451c.533-.31.715-.999.408-1.537a1.108 1.108 0 0 0-1.522-.412L16.778 7.04l.826-2.114c.19-.59-.13-1.226-.714-1.418a1.111 1.111 0 0 0-1.404.722l-1.042 4.172-2.83 1.65V6.75l3.055-2.997a1.133 1.133 0 0 0-.083-1.59 1.106 1.106 0 0 0-1.573.084l-1.4 1.78V1.125A1.12 1.12 0 0 0 10.5 0a1.12 1.12 0 0 0-1.114 1.125v2.902l-1.4-1.78a1.106 1.106 0 0 0-1.572-.083 1.133 1.133 0 0 0-.083 1.589L9.386 6.75v3.301l-2.83-1.65-1.042-4.172a1.111 1.111 0 0 0-1.404-.722 1.127 1.127 0 0 0-.714 1.418l.826 2.114-2.488-1.45A1.108 1.108 0 0 0 .212 6 1.131 1.131 0 0 0 .62 7.537l2.488 1.451-2.225.335c-.602.129-.986.726-.858 1.334.127.607.719.995 1.32.866l4.097-1.174L8.625 12l-3.183 1.65-4.097-1.173a1.114 1.114 0 0 0-1.32.867 1.125 1.125 0 0 0 .858 1.334l2.225.334L.62 16.463c-.533.31-.715.999-.408 1.537.308.538.99.722 1.522.412l2.488-1.451-.826 2.114c-.098.303-.064.634.095.91a1.111 1.111 0 0 0 2.023-.215l1.042-4.17 2.83-1.651v3.301l-3.055 2.997a1.133 1.133 0 0 0 .083 1.59 1.106 1.106 0 0 0 1.573-.084l1.4-1.78v2.902A1.12 1.12 0 0 0 10.5 24a1.12 1.12 0 0 0 1.114-1.125v-2.902l1.4 1.78a1.106 1.106 0 0 0 1.572.083 1.133 1.133 0 0 0 .083-1.589l-3.055-2.997v-3.301l2.83 1.65 1.042 4.172c.19.59.819.914 1.404.722.584-.193.904-.827.714-1.418l-.826-2.114 2.488 1.45c.533.311 1.214.127 1.522-.411a1.131 1.131 0 0 0-.408-1.537l-2.488-1.451 2.225-.335c.322-.068.581-.271.734-.538z",
    id: "be2dgjsnca"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "esqqpddb5b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#be2dgjsnca",
    transform: "rotate(-180 16.5 12)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    mask: "url(#esqqpddb5b)",
    transform: "rotate(-180 16.25 12)",
    d: "M22.5 24H10V0h12.5"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.54 20.483-1.196 2.924M11.454 0v5.625l-.222.004A6.383 6.383 0 0 0 5.086 12a6.382 6.382 0 0 0 6.372 6.375V24a.94.94 0 0 1-.88-.593l-1.196-2.924a.844.844 0 0 0-1.225-.398L5.47 21.748c-.726.449-1.632-.209-1.428-1.038l.751-3.07a.844.844 0 0 0-.757-1.042l-3.151-.233c-.852-.063-1.198-1.128-.546-1.68l2.412-2.04a.844.844 0 0 0 0-1.289L.339 9.315c-.652-.552-.306-1.616.546-1.68l3.15-.233a.844.844 0 0 0 .758-1.042l-.751-3.07c-.204-.83.702-1.487 1.428-1.038l2.687 1.664a.844.844 0 0 0 1.225-.399L10.578.593A.94.94 0 0 1 11.454 0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M1.5 24V0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeasons);
export default __webpack_public_path__ + "static/media/seasons.517e1cbb90659e0069c8115baa7eef58.svg";
export { ForwardRef as ReactComponent };